The success result for the `postPosition` mutation.
